// hooks/useSettingsSections.ts — hook for settings sidebar sections.
//
// Settings sections are static in the prototype (no store mutation), so
// this hook returns the seed data directly.
// Components must NOT import settingsSectionsService or seedSettingsSections directly.

import { SETTINGS_GROUP_LABELS, seedSettingsSections } from '@/core/data/settings-sections';
import type { SettingsGroup, SettingsSection } from '@/core/models/settings';

export interface SettingsSectionsHook {
  /** All settings sections in order. */
  sections: SettingsSection[];
  /** Look up a section by id. Returns undefined if not found. */
  getSection: (id: string) => SettingsSection | undefined;
  /** Sidebar heading for a section group (sentence case). */
  groupLabel: (group: SettingsGroup) => string;
}

/** Returns the static settings sections list + a lookup helper. */
export function useSettingsSections(): SettingsSectionsHook {
  return {
    sections: seedSettingsSections,
    getSection: (id) => seedSettingsSections.find((s) => s.id === id),
    groupLabel: (group) => SETTINGS_GROUP_LABELS[group],
  };
}
